import { environment } from 'src/environments/environment';
import {IsContainHttp} from './common.func';


export const CUSTOM_URL_SCHEME = 'gukeoapp';

// FIXED: 서버주소 환경변수로 이동.
export const GUKEO_API_URL1 = environment.server;
  // 'https://api.verysimple.org';   // real server URL
  // 'https://dev-api.verysimple.org';   // real server URL
  // 'http://localhost:8000';      // debug local server
  // 'https://han-api.verysimple.org'; // production 서버
  // 'https://han-api-dev.verysimple.org'; // development 서버


export const GUKEO_API_URL = GUKEO_API_URL1 + '/';


export const USER_API_URL             = 'v1/user/';
export const USER_LOGIN_API_URL       = USER_API_URL + 'login/';
export const USER_REGISTER_API_URL    = USER_API_URL + 'register/';
export const USER_FCM_TOKEN_API_URL   = USER_API_URL + 'fcm-token/';

export const WORD_API_URL             = 'v1/word/';
export const WORD_DETAIL_API_URL      = WORD_API_URL + 'detail/';
export const WORD_API_IN_URL          = WORD_API_URL + 'in/';
export const WORD_LINK_API_URL        = WORD_API_URL + 'link/';
export const WORD_BOOKMARK_API_URL    = WORD_API_URL + 'bookmark/';
export const WORD_SAJA_BOOKMARK_API_URL = WORD_API_URL + 'saja/bookmark/';
export const WORD_HOMONYM_API_URL     = WORD_API_URL + 'homonym/';

export const DIALECT_API_URL          = 'v1/dialect2/';
export const DIALECT_DETAIL_API_URL   = DIALECT_API_URL + 'detail/';
export const DIALECT_LINK_API_URL     = DIALECT_API_URL + 'link/';
export const DIALECT_LINKS_API_URL     = DIALECT_API_URL + 'links/';
export const DIALECT_IN_API_URL       = DIALECT_API_URL + 'in/';
export const DIALECT_BOOKMARK_API_URL = DIALECT_API_URL + 'bookmark/';

export const PROVERB_API_URL          = 'v1/proverb/';
export const PROVERB_DETAIL_API_URL   = PROVERB_API_URL + 'detail/';
export const PROVERB_IN_API_URL       = PROVERB_API_URL + 'in/';
export const PROVERB_BOOKMARK_API_URL = PROVERB_API_URL + 'bookmark/';

export const VIDEO_API_URL            = 'v1/video2/';
export const VIDEO_IN_API_URL         = VIDEO_API_URL + 'in/';
export const VIDEO_BOOKMARK_API_URL   = VIDEO_API_URL + 'bookmark/';
export const VIDEO_STORY_API_URL      = VIDEO_API_URL + 'story/';
export const VIDEO_CITY_API_URL       = VIDEO_API_URL + 'city/';

export const BBS_API_URL              = 'v1/board/';


export const TOTAL_API_URL            = 'v1/total/';
export const TOTAL_SEARCH_API_URL     = TOTAL_API_URL + 'search/';
export const TOTAL_BOOKMARK_INFO_API_URL = TOTAL_API_URL + 'bookmark/';
export const TOTAL_LINK_INFO_API_URL = TOTAL_API_URL + 'link/';

export const EXAMPLE_API_URL         = 'v1/example/';
export const EXAMPLE_DETAIL_API_URL  = EXAMPLE_API_URL + 'detail/';
export const EXAMPLE_TREE_API_URL    = EXAMPLE_API_URL + 'tree/';

export const SASEUNG_API_URL          = 'v1/saseung/';
export const SASEUNG_DETAIL_API_URL   = SASEUNG_API_URL + 'detail/';
export const SASEUNG_HUN_API_URL      = SASEUNG_API_URL + 'hun/';
export const SASEUNG_HUNS_API_URL      = SASEUNG_API_URL + 'huns/';
export const SASEUNG_HANJA_API_URL     = SASEUNG_API_URL + 'hanja/';

export const SASEUNG2_API_URL         = 'v1/saseung2/';
export const SASEUNG2_HANGUL_API_URL  = SASEUNG2_API_URL + 'hangul/';
export const SASEUNG2_HANJA_API_URL   = SASEUNG2_API_URL + 'hanja/';

export const SASEUNG3_API_URL         = 'v1/saseung3/';
export const SASEUNG3_HANGUL_API_URL  = SASEUNG3_API_URL + 'hangul/';
export const SASEUNG3_HANJA_API_URL   = SASEUNG3_API_URL + 'hanja/';
export const SASEUNG3_BOOKMARK_API_URL = SASEUNG3_API_URL + 'bookmark/';
export const SASEUNG3_WORDS_API_URL   = SASEUNG3_API_URL + 'words/';
export const SASEUNG3_STATS_API_URL   = SASEUNG3_API_URL + 'stats/';

export const HANJA_API_URL            = 'v1/hanja/';

export const SYSTEM_API_URL           = 'v1/system/';
export const SYSTEM_INFO_API_URL      = SYSTEM_API_URL + 'info/';
export const SYSTEM_GREETING_API_URL    = SYSTEM_API_URL + 'greeting/';

export const CONTENT_TYPE_JSON_UTF8   = {'Content-Type': 'application/json; charset=utf-8'};

// 책갈피 네이버 로그인
// export const NAVER_CLIENT_ID = environment.naverClientId; // 사용 안함.
// export const NAVER_CALLBACK_URL = environment.naverCallbackUrl; // 사용 안함.

export const SNS_API_URL              = 'v1/sns/';
export const SNS_NAVER_API_URL        = SNS_API_URL + 'naver/';

export type PAGE = {
  count: number;
  total_pages?: number;
  page_size?: number;
  next: string;
  previous: string;
  results: [];
};


/******************************************************************************
 * 단어 목록에서 단어 난이도 필터 수치
 *****************************************************************************/
export enum STAR_FILTER {
  NONE,
  ALL = 0,

  ONE,
  TWO,
  THREE,
  FOUR,

  MAX,
}


/**
 * 영상의 카테고리, 서버와 일치해야 함. (임의로 변경 금지)
 */
export enum VIDEO_CATEGORY {
  NONE,

  WORD,
  DIALECT,
  COOL_EXPR,
  WRONG_EXPR,
  PROVERB,
  LOAN_WORD,
  HOMONYM,
}


/**
 * 게시판 구분자
 */
export enum BBS_CATEGORY {
  NONE,   // 내부용
  NOTICE, // 공지
  USAGE,  // 사용법
}


// 서버에서 보내주는, 단어당 최대 예문 소리 파일 갯수
export const MAX_EXAMPLE_VOICE = 10;


export type GREETING = {
  title: string;
  message: string;
};


export type SERVER_INFO = {
  status: string;
  version: {
    ios: {
      soft: string;
      hard: string;
    };
    android: {
      soft: string;
      hard: string;
    };
  };
};


export function api_url(url: string): string {
  return IsContainHttp(url) ? url : GUKEO_API_URL1 + url;
}

export function api_url_replace(content: string): string {
  return content.split('"/media/').join('"' + GUKEO_API_URL1 + '/media/');
}
